import { useEffect, useState } from "react";
import { Mail, BookOpen, ClipboardList, Clapperboard, FileText, Presentation } from "lucide-react";
import DesignTab from "@/components/DesignTab";
import MarketingAITab from "@/components/MarketingAITab";
import FormsTab from "@/components/FormsTab";
import PromoVideosTab from "@/components/promo/PromoVideosTab";
import PostsTab from "@/components/posts/PostsTab";
import SlidesTab from "@/components/slides/SlidesTab";

// Marketing AI = sub-tabs: Emails (templates/designer), Media (promo videos), Posts, Forms, Q&A (knowledge base).
export default function MarketingHub({ userRecordId, userId, isAdmin = false }) {
  const p = new URLSearchParams(window.location.search);
  const fromUrl = p.get("sub") || (p.get("kb") === "forms" ? "forms" : p.get("kb") || p.get("tab") === "marketing-ai" ? "kb" : "");
  const [sub, setSub] = useState(["emails", "kb", "forms", "media", "posts", "slides"].includes(fromUrl) ? fromUrl : "emails");
  const [openPost, setOpenPost] = useState(null); // "Share to Post" from Slides → open that post in the Posts editor
  useEffect(() => {
    const h = (e) => { if (e.detail?.sub) { setOpenPost(e.detail.post || null); setSub(e.detail.sub); } };
    window.addEventListener("marketing:sub", h);
    return () => window.removeEventListener("marketing:sub", h);
  }, []);
  const btn = (v, Icon, label, testId) => (
    <button type="button" onClick={() => setSub(v)} aria-pressed={sub === v}
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-3.5 h-9 text-sm font-semibold transition-colors ${sub === v ? "bg-violet-600 text-white" : "bg-white text-zinc-600 border border-zinc-200 hover:bg-zinc-50"}`}
      data-testid={testId}>
      <Icon size={14} /> {label}
    </button>
  );
  return (
    <div data-testid="marketing-hub">
      <div className="flex items-center gap-2 mb-4 overflow-x-auto" data-testid="marketing-subtabs">
        {btn("emails", Mail, "Emails", "marketing-subtab-emails")}
        {btn("media", Clapperboard, "Media", "marketing-subtab-media")}
        {btn("posts", FileText, "Posts", "marketing-subtab-posts")}
        {btn("slides", Presentation, "Slides", "marketing-subtab-slides")}
        {btn("forms", ClipboardList, "Forms", "marketing-subtab-forms")}
        {btn("kb", BookOpen, "Q&A", "marketing-subtab-kb")}
      </div>
      {sub === "emails" && <DesignTab userRecordId={userRecordId} userId={userId} />}
      {sub === "kb" && <MarketingAITab userRecordId={userRecordId} />}
      {sub === "forms" && <FormsTab userRecordId={userRecordId} />}
      {sub === "media" && <PromoVideosTab userRecordId={userRecordId} />}
      {sub === "posts" && <PostsTab userRecordId={userRecordId} isAdmin={isAdmin} openPost={openPost} />}
      {sub === "slides" && <SlidesTab userRecordId={userRecordId} isAdmin={isAdmin} />}
    </div>
  );
}
